import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { useCreateModelSize } from '../api';
import { ModelSizeForm } from '../components';
import { ModelSizeFormValues } from '../validations';

export const NewModelSizePage: FC = () => {
  const navigate = useNavigate();

  const { createModelSizeMutation } = useCreateModelSize();

  const saveModelSize = async (values: ModelSizeFormValues) => {
    try {
      await createModelSizeMutation.mutateAsync({
        value: values.value,
        sortOrder: values.sortOrder,
        hints: values.hints.map((hint) => ({
          value: hint.value,
          measure: hint.measure,
          sortOrder: hint.sortOrder,
        })),
      });
      navigate(Routes.ModelSizes, { replace: true });
      toast.success(`Model size “${values.value}” added successfully!`);
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <ModelSizeForm onSubmit={saveModelSize}>
      <PageHeader
        title="New Model Size"
        asChildPage
        backPath={Routes.ModelSizes}
        actions={[
          <Button
            key="create-model-size"
            type="submit"
            data-testid="create-model-size-button"
            isLoading={createModelSizeMutation.isPending}
            startIcon={<PlusSquareIcon />}
          >
            Create new size
          </Button>,
        ]}
      />
    </ModelSizeForm>
  );
};
